/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yaml_Output_LabelInputs */

const en_yaml_output_label = /** @type {(inputs: Yaml_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML Output`)
};

const ko_yaml_output_label = /** @type {(inputs: Yaml_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML 출력`)
};

const ja_yaml_output_label = /** @type {(inputs: Yaml_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML出力`)
};

/**
* | output |
* | --- |
* | "YAML Output" |
*
* @param {Yaml_Output_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const yaml_output_label = /** @type {((inputs?: Yaml_Output_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yaml_Output_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yaml_output_label(inputs)
	if (locale === "ko") return ko_yaml_output_label(inputs)
	return ja_yaml_output_label(inputs)
});